import { Template } from './template';

export interface Outward {
  id: string;
  isUnvaultComplete: boolean;
  unvaultCompleteRemarks: string;
  customerId: string;
  departmentId: string;
  isVerified: boolean;
  verificationRemarks: string;
  isApproved: boolean;
  approvalRemarks: string;
  pickerName: string;
  pickerPhoneNumber: number;
  isMovementComplete: boolean;
  movementCompleteRemarks: string;
  isPacked: boolean;
  packingRemarks: string;
  billType: string;
  billingAmount: string;
  billingCode: string;
  outwardDateTime: string;
  isActive: boolean;
  isPickerAssigned: boolean;
  isBilled: boolean;
  deliveryWorkflows: Template[];
}
export const initialOutwardState = {
  id: '',
  isUnvaultComplete: false,
  unvaultCompleteRemarks: '',
  customerId: '',
  departmentId: '',
  isVerified: false,
  verificationRemarks: '',
  isApproved: false,
  approvalRemarks: '',
  pickerName: '',
  pickerPhoneNumber: 0,
  isMovementComplete: false,
  movementCompleteRemarks: '',
  isPacked: false,
  packingRemarks: '',
  isActive: true,
  billType: '',
  billingAmount: '',
  billingCode: '',
  outwardDateTime: new Date().toISOString(),
  isPickerAssigned: false,
  isBilled: false,
  deliveryWorkflows: [],
};
